module.exports = __webpack_public_path__ + "static/media/pen_blue.11f43d68.svg";